import clsx from 'clsx'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'

interface Props {
  width: number
  height: number
  type?: IconType
  border?: boolean
}

const NoImage = ({ width, height, type = IconType.IMAGE, border = false }: Props) => {
  return (
    <span
      className={clsx(
        `bg-surface-disabled grid aspect-square place-content-center w-${width / 4} h-${
          height / 4
        } `,
        width >= 80 ? 'rounded-lg' : 'rounded',
        border && 'border-primary border'
      )}
    >
      <Icon type={type} color={IconColor.DISABLED} line />
    </span>
  )
}

export default NoImage
